import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from './ServerService';
import {
  ApiImportacaoEntreLojas, LojaImportacao, PreviaImportacao, RetornoProdutoImportacao, RevisaoImportacao
} from '../compartilhado/importacao-entre-lojas/fluxo-importacao-entre-lojas';

@Injectable({providedIn: 'root'})
export class ImportacaoEntreLojasService extends ServerService implements ApiImportacaoEntreLojas {
  constructor(http: HttpClient) { super(http); }

  listeLojas(): Promise<LojaImportacao[]> {
    return this.obtenha('/catalogos/importacao-entre-lojas/lojas', {});
  }

  obtenhaPrevia(idOrigem: number): Promise<PreviaImportacao> {
    return this.obtenha(`/catalogos/importacao-entre-lojas/${idOrigem}/previa`, {});
  }

  revise(idOrigem: number, idsProdutos: number[]): Promise<RevisaoImportacao> {
    return this.facaPost(`/catalogos/importacao-entre-lojas/${idOrigem}/revisao`, {idsProdutos});
  }

  importeProduto(idOrigem: number, idProduto: number): Promise<RetornoProdutoImportacao> {
    return this.facaPost(`/catalogos/importacao-entre-lojas/${idOrigem}/produtos/${idProduto}`, {});
  }
}
